module.exports = __webpack_public_path__ + "img/331.72d26155.jpg";